import { Input } from "antd";
import React, {useState} from "react";
import styled from "styled-components";
import { OpenEyeIcon, CloseEyeIcon } from "@assets";

const PasswordInput = styled(Input.Password)`
	height: 55px;
	border-radius: 16px;
	background: #FFF;
	font-family: 'Inter', 'Yati' !important;

	input:hover {
		border: none !important;
	}

	input::placeholder {
		color: #979797 !important;
		font-size: 16px !important;
		font-style: normal;
		font-family: 'Inter', 'Yati' !important;
		font-weight: 400;
	}

	input {
		color: #342309 !important;
		text-align: left !important;
		font-size: 16px !important;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
		font-family: 'Inter', 'Yati' !important;
		background-color: #FFF !important;
	}

	&&& {
		text-align: left !important;
		padding-left: 13px;
		font-size: 16px !important;
		font-style: normal;
		font-weight: 600;
		font-family: 'Inter', 'Yati' !important;
		line-height: normal;
	}
`;

const InputPassword = ({value, placeholder, ...props }) => {
	const [isVisible, setIsVisible] = useState(false);

	const handleKeyDown = (event) => {
		const key = event.key;
		const isAllowedKey = /^[0-9\b]+$/.test(key);
		if (!isAllowedKey && key !== "Backspace") {
			event.preventDefault();
		}
	};

	const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

	const renderIcon = () => {
    return (
      <div style={{marginTop: 6}}>
       { 
        !value ? ''
          : isVisible ? <OpenEyeIcon onClick={toggleVisibility}/> 
          : <CloseEyeIcon onClick={toggleVisibility}/> 
        }
      </div>
    )
  }

	return (
		<PasswordInput
			size="large"
			placeholder={placeholder}
			onKeyDown={handleKeyDown}
			iconRender={renderIcon}
			{...props}
		/>
	);
};

export default InputPassword;
